<div class="flex flex-row items-stretch justify-center m-auto gap-2">
    @if (canDisplayDefaultSelectionActions() || this.mapEditModeService.activeGeometryType()) {
        <app-select
            [clearSelection]="selectionService.mapClearSelectedLayer()"
            [defaultValue]="selectionService.layersSelectedDefaultOptions()"
            [isMultiSelect]="true"
            [isSimpleSelectStyle]="true"
            [options]="filteredLayerSelectionOption()"
            [placeholder]="'selectionLayers'"
            [sortOptions]="true"
            (selectedOptionsChange)="
                geographicFilterService.updateLayerSelectionState($event, selectionService.selectionLayerOptions())
            " />
    }

    <app-button
        [disabled]="cannotDrawPolygon()"
        [htmlType]="'button'"
        [icon]="['far', 'draw-polygon']"
        [iconSize]="'lg'"
        [tooltip]="drawPolygonTooltip() | transloco"
        [type]="mapDrawService.isPolygonDrawSessionActive() ? ButtonType.PRIMARY : ButtonType.SECONDARY"
        (click)="selectionService.toggleDrawPolygon()" />

    <app-button
        [disabled]="mapDrawService.hasDrawnPolygon()"
        [htmlType]="'button'"
        [icon]="['fas', 'hexagon']"
        [iconSize]="'lg'"
        [tooltip]="selectPolygonLayerTooltip() | transloco"
        [type]="
            selectionService.selectionMode() === FilterModeEnum.SELECT_ZONE ? ButtonType.PRIMARY : ButtonType.SECONDARY
        "
        (click)="toggleLayerSelection()" />
    @if (selectionService.selectionMode() === FilterModeEnum.SELECT_ZONE) {
        <app-select
            [clearSelection]="selectionService.mapClearSelectedLayer()"
            [defaultValue]="layerExtentSelectedDefaultOptions()"
            [isDisabled]="mapDrawService.hasDrawnPolygon()"
            [isMultiSelect]="false"
            [isSimpleSelectStyle]="true"
            [options]="selectionService.polygonLayerOptions()"
            [placeholder]="'extentLayer'"
            [sortOptions]="true"
            (selectedOptionsChange)="onLayerExtentChange($event)" />
    }

    <app-button
        [disabled]="!isSelectionClearable()"
        [htmlType]="'button'"
        [icon]="['fad', 'eraser']"
        [iconSize]="'lg'"
        [tooltip]="'unselect' | transloco"
        [type]="ButtonType.SECONDARY"
        (click)="clearSelection()" />

    @if (mapEditModeService.isMapEditModeActive()) {
        <app-delete-edit-button
            [disabled]="isDeleteButtonDisabled() || !isSelectionApplicable()"
            [tooltip]="deleteTooltip() | transloco"
            (delete)="mapEditModeService.requestDelete(featureService.data())" />
    }

    <app-button
        [disabled]="!isSelectionApplicable()"
        [htmlType]="'button'"
        [icon]="['fas', 'check']"
        [iconSize]="'lg'"
        [tooltip]="!isSelectionApplicable() ? (validTooltipKey() | transloco) : ''"
        [type]="ButtonType.SECONDARY"
        (click)="selectionService.apply()" />

    @if (
        canDisplayDefaultSelectionActions() &&
        !this.mapEditModeService.activeGeometryType() &&
        !this.mapEditModeService.activeEditSelectionGeometryType()
    ) {
        <app-button
            [htmlType]="'button'"
            [icon]="['fas', 'arrow-down-to-line']"
            [iconSize]="'lg'"
            [type]="ButtonType.SECONDARY"
            (click)="dataExportService.openShapeExportModal(ExportSelectionModeEnum.GEOGRAPHIC_ZONE)" />
    }
</div>
